import axios from "axios";

import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;

// Create headers getter to ensure fresh auth token
const getHeaders = () => ({
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  Authorization: getCookie("mawalog"),
});

// Generic API request handler
export const fetchData = async (endpoint, errorContext = "data") => {
  try {
    const response = await axios.get(`${apiUrl}${endpoint}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (err) {
    console.error(`Error fetching ${errorContext}:`, err);
    throw err;
  }
};
